import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/features/marketing/content/content-page";
import { body } from "@/features/marketing/content/pages/guide-vendor-questions";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/guides/questions-to-ask-wedding-vendors")({
  head: SEO["/guides/questions-to-ask-wedding-vendors"],
  component: () => <ContentPage path="/guides/questions-to-ask-wedding-vendors" body={body} />,
});
